<!--
  Accordion.vue

  this component have following props:

  1)'accBtn' - string and required. used as accordion button text.
  2)'isOpen' - boolean and default to be false. if it is given, and is
        true, accordion is opened when is rendered.
  3)'id' - give id to accordion button. 
-->

<template>
  <div class="accordion-wrapper">
    <button
      :id="buttonId"
      :aria-controls="contentId"
      :class="['non-button-style', 'accordion-button', { 'with-icon': accordionClass.includes('with-icon'), isOpen: accordionState }]"
      :aria-expanded="accordionState"
      @click="accordionToggle"
    >
      <h6>
        <!-- CORS policy restricts svg <use> from displaying icon assets -->
        <div v-if="iconUrl && !isCrm">
          <svg >
            <use :xlink:href="iconUrl" />
          </svg>
        </div>
        <img v-else-if="iconUrl && isCrm" :src="iconUrl" alt="" style="max-width: 20px" />
        {{ accBtn }}
      </h6>
      <svg>
        <use xlink:href="/assets/public/images/icons.svg#down-arrow" />
      </svg>
    </button>
    <div :id="contentId" role="region" :aria-labelledby="buttonId" :class="contentClass">
      <div v-show="accordionState">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  name: 'Accordion',

  props: {
    accBtn: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    /**
     * Path to the icon to be displayed in the accordion header. Moves down arrow to the right of the name.
     *
     * @prop {string} iconUrl - The URL of the icon.
     * @example '/assets/public/images/icons.svg#included'
     */
    iconUrl: {
      type: String,
    },
    /**
     * Additional classes to be added to the accordion.
     *
     * @prop {string} accordionClass - The classes to be added to the accordion.
     * @example currently supports: 'with-icon', 'secondary'
     */
    accordionClass: {
      type: String,
      default: '',
    },
    /**
     * Additional classes to be added to the accordion.
     *
     * @prop {boolean} isCrm - If the accordion is used in CRM.
     * @example true or false
     * @default false
     * @description If true, the iconUrl will be used as an image instead of an SVG.
     */
    isCrm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      accordionState: this.isOpen,
      buttonId: this.id ? this.id : uuid(),
      contentId: uuid(),
    };
  },

  watch: {
    isOpen(newState) {
      this.accordionState = newState;
    },
  },

  methods: {
    accordionToggle() {
      this.accordionState = !this.accordionState;
      this.$emit('update:accordionState', this.accordionState);
    },
  },

  computed: {
    contentClass() {
      const contentClass = `accordion-content ${this.accordionClass}`;
      if (this.accordionState) {
        return `${contentClass} expanded-aria no-bullets`;
      }
      return contentClass;
    },
  },
};
</script>
